import React from 'react';
import { Outlet } from 'react-router-dom';
import TopBar from '../../components/TopBar/TopBar';
import './Dashboard.css';

const Dashboard = () => {
  return (
    <div className="dashboard">
      <TopBar />
      <div className="dashboard-content">
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
